/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AppliedMethodologySerializer = {
  allocation_method: AppliedMethodologySerializer.allocation_method;
  maturity?: number;
  volatility?: number;
  weight: number;
  cap_table: number;
  opm_backsolve_date?: string;
};
export namespace AppliedMethodologySerializer {
  export enum allocation_method {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
  }
}
